// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".drawing-media-frame{width:100%;height:350px;border:1px solid #8885;border-radius:4px;background:white}", ""]);
// Exports
module.exports = exports;
